/**
 * 地图模块
 * */
import WMTS from 'ol/source/WMTS'
import TileLayer from 'ol/layer/Tile'
import WMTSTileGrid from 'ol/tilegrid/WMTS'
import {get as getProjection} from 'ol/proj'
import {getWidth,getTopLeft} from 'ol/extent'


//计算
let projection = getProjection('EPSG:4326');
let projectionExtent = projection.getExtent();
let size = getWidth(projectionExtent) / 256;
let resolutions = new Array(18);
let matrixIds = new Array(18);
for(let z=1;z<19;++z){
  resolutions[z]=size/Math.pow(2,z);
  matrixIds[z]=z;
}

//基础参数
const TDM_MAPKEY ="f7c8bf76626508dc1c33f71718c9f8d8";                      //天地图的Key
const TDM_BASIC_URL = "http://t0.tianditu.gov.cn";                         //基础服务路径
const TDM_SOURCE_VEC_C = TDM_BASIC_URL+"/vec_c/wmts?tk="+TDM_MAPKEY;       //矢量底图 - 经纬度投影
const TDM_SOURCE_CVA_C = TDM_BASIC_URL+"/cva_c/wmts?tk="+TDM_MAPKEY;       //矢量注记 - 经纬度投影
const TDM_SOURCE_IMG_C = TDM_BASIC_URL+"/img_c/wmts?tk="+TDM_MAPKEY;       //影像地图 - 经纬度投影
const TDM_SOURCE_CIA_C = TDM_BASIC_URL+"/cia_c/wmts?tk="+TDM_MAPKEY;       //影像地图 - 经纬度投影

const TDM_SOURCE_IBO_C = TDM_BASIC_URL+"/ibo_c/wmts?tk="+TDM_MAPKEY;
const TDM_SOURCE_EVA_C = TDM_BASIC_URL+"/eva_c/wmts?tk="+TDM_MAPKEY;

/**
 * @description 天地图数据源列表
 * */
const TDM_LIST =[
  {
    description:"矢量底图-经纬度投影",
    visible:false,
    name:"TDM_LAYER_VEC_C",
    layer:"vec",
    matrixSet:"c"
  },
  {
    description:"影像底图-经纬度投影",
    visible:true,
    name:"TDM_LAYER_IMG_C",
    layer:"img",
    matrixSet:"c"
  },
  {
    description:"矢量注记-经纬度投影",
    visible:true,
    name:"TDM_LAYER_VEC_C",
    layer:"cva",
    matrixSet:"c"
  }
];

/**
 * @description 读取天地图图层列表
 * */
const GET_TMDLAYERS = function(){
  let TDM_LAYERS = [];
  TDM_LIST.forEach(item=>{
    let TDM_URL = TDM_BASIC_URL+"/"+item.layer+"_"+item.matrixSet+"/wmts?tk="+TDM_MAPKEY;
    let layer_item = new TileLayer({
      visible: item.visible,
      title:item.name,
      name:item.name,
      source:new WMTS({
        crossOrigin:'anonymous',
        url:TDM_URL,
        layer:item.layer,
        matrixSet:item.matrixSet,
        format:'tiles',
        style:'default',
        projection:projection,
        tileGrid:new WMTSTileGrid({
          origin:getTopLeft(projectionExtent),
          resolutions:resolutions,
          matrixIds:matrixIds
        }),
        wrapX:true
      })
    });
    TDM_LAYERS.push(layer_item);
  });
  return TDM_LAYERS;
};

/**
 * @description 加载默认的天地图图层资源
 * */
const LOAD_DEFAULT_TDMLAYERS = function(map)
{
  let tmd_layers  = GET_TMDLAYERS();
  tmd_layers.forEach(item=>{
    map.addLayer(item);
  })
};












/**
 * 默认地图 - 矢量底图 - 经纬度投影
 * */
let TDM_LAYER_VEC_C = new TileLayer({
  title:"TDM_LAYER_VEC_C",
  source:new WMTS({
    crossOrigin:'anonymous',
    url:TDM_SOURCE_VEC_C,
    layer:'vec',
    matrixSet:'c',
    format:'tiles',
    style:'default',
    projection:projection,
    tileGrid:new WMTSTileGrid({
      origin:getTopLeft(projectionExtent),
      resolutions:resolutions,
      matrixIds:matrixIds
    }),
    wrapX:true
  })
});
TDM_LAYER_VEC_C.name = "TDM_LAYER_VEC_C";

/**
 * 基础服务 - 矢量注记 - 经纬度投影
 * */
let TDM_LAYER_CVA_C = new TileLayer({
  title:"TDM_LAYER_CVA_C",
  source:new WMTS({
    crossOrigin:'anonymous',
    url:TDM_SOURCE_CVA_C,
    layer:'cva',
    matrixSet:'c',
    format:'tiles',
    style:'default',
    projection:projection,
    tileGrid:new WMTSTileGrid({
      origin:getTopLeft(projectionExtent),
      resolutions:resolutions,
      matrixIds:matrixIds
    }),
    wrapX:true
  })
});
TDM_LAYER_CVA_C.name = "TDM_LAYER_CVA_C";




/**
 * 基础服务 - 影像图 - 经纬度投影
 * */
let TDM_LAYER_IMG_C = new TileLayer({
  title:"TDM_LAYER_IMG_C",
  source:new WMTS({
    crossOrigin:'anonymous',
    url:TDM_SOURCE_IMG_C,
    layer:'img',
    matrixSet:'c',
    format:'tiles',
    style:'default',
    projection:projection,
    tileGrid:new WMTSTileGrid({
      origin:getTopLeft(projectionExtent),
      resolutions:resolutions,
      matrixIds:matrixIds
    }),
    wrapX:true
  })
});
TDM_LAYER_IMG_C.name = "TDM_LAYER_IMG_C";


/**
 * 基础服务 - 影像注记 - 经纬度投影
 * */
let TDM_LAYER_CIA_C = new TileLayer({
  title:"TDM_LAYER_CIA_C",
  source:new WMTS({
    crossOrigin:'anonymous',
    url:TDM_SOURCE_CIA_C,
    layer:'cia',
    matrixSet:'c',
    format:'tiles',
    style:'default',
    projection:projection,
    tileGrid:new WMTSTileGrid({
      origin:getTopLeft(projectionExtent),
      resolutions:resolutions,
      matrixIds:matrixIds
    }),
    wrapX:true
  })
});
TDM_LAYER_CIA_C.name = "TDM_LAYER_CIA_C";








/**
 * 基础服务 - 全球境界 - 经纬度投影
 * */
let TDM_LAYER_IBO_C = new TileLayer({
  title:"TDM_LAYER_IBO_C",
  source:new WMTS({
    crossOrigin:'anonymous',
    url:TDM_SOURCE_IBO_C,
    layer:'ibo',
    matrixSet:'c',
    format:'tiles',
    style:'default',
    projection:projection,
    tileGrid:new WMTSTileGrid({
      origin:getTopLeft(projectionExtent),
      resolutions:resolutions,
      matrixIds:matrixIds
    }),
    wrapX:true
  })
});
TDM_LAYER_IBO_C.name = "TDM_LAYER_IBO_C";



/**
 * 基础服务 - 矢量英文注记
 * */
let TDM_LAYER_EVA_C = new TileLayer({
  title:"BSD:TDM_LAYER_EVA_C",
  name:"BSD:TDM_LAYER_EVA_C",
  source:new WMTS({
    crossOrigin:'anonymous',
    url:TDM_SOURCE_EVA_C,
    layer:'eva',
    matrixSet:'c',
    format:'tiles',
    style:'default',
    projection:projection,
    tileGrid:new WMTSTileGrid({
      origin:getTopLeft(projectionExtent),
      resolutions:resolutions,
      matrixIds:matrixIds
    }),
    wrapX:true
  })
});
TDM_LAYER_EVA_C.name = "BSD:TDM_LAYER_EVA_C";



/**
 * 基础服务 - 矢量英文注记
 * */
let BSD_TDM_LAYER_EVA_C = new TileLayer({
  title:"BSD_TDM_LAYER_EVA_C",
  name:"BSD_TDM_LAYER_EVA_C",
  source:new WMTS({
    crossOrigin:'anonymous',
    url:TDM_SOURCE_EVA_C,
    layer:'eva',
    matrixSet:'c',
    format:'tiles',
    style:'default',
    projection:projection,
    tileGrid:new WMTSTileGrid({
      origin:getTopLeft(projectionExtent),
      resolutions:resolutions,
      matrixIds:matrixIds
    }),
    wrapX:true
  })
});
BSD_TDM_LAYER_EVA_C.name = "BSD_TDM_LAYER_EVA_C";






export  {TDM_LIST,GET_TMDLAYERS,LOAD_DEFAULT_TDMLAYERS,
  TDM_MAPKEY,
  TDM_SOURCE_VEC_C,
  TDM_LAYER_VEC_C,
  TDM_LAYER_CVA_C,
  TDM_LAYER_IMG_C,
  TDM_LAYER_CIA_C,

  TDM_LAYER_EVA_C,
  TDM_LAYER_IBO_C,
  BSD_TDM_LAYER_EVA_C
}



// WEBPACK FOOTER //
// ./src/components/map/common/constant.js